import { httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import { functions } from "../../firebase";
import getCustomErrorMessage from "../../utils/firebaseErrors";
import { handleAuthError, isAuthError } from "../../utils/handleAuthError";
import type { FirebaseError } from "firebase/app";
import type { Referente } from "../../firebase/firestore/usuarios";
import UserRole from "../../interfaces/UserRole";

interface UserAdminRegister {
  name: string;
  lastName: string;
  email: string;
  password: string;
  countryCode: string;
  lockerCode: string;
  phone: string;
  role: UserRole;
  vendedor?: Referente;
  referidoPor?: Referente;
}

/**
 * Registra un usuario desde el panel de Admin.
 * Usa la Cloud Function createUserByAdmin para que el Admin siga autenticado
 * y no se disparen reglas de Firestore con el nuevo usuario.
 */
export async function registerUserService(user: Partial<UserAdminRegister>) {
  const {
    email,
    password,
    name,
    lastName,
    phone,
    countryCode,
    role,
    vendedor,
    referidoPor,
  } = user;

  if (!email || !name || !password || !lastName) return null;

  try {
    const createUserByAdmin = httpsCallable<
      {
        email: string;
        password: string;
        name: string;
        lastName: string;
        phone?: string;
        countryCode?: string;
        role?: string;
        vendedor?: Referente;
        referidoPor?: Referente;
      },
      { uid: string; email: string }
    >(functions, "createUserByAdmin");

    const { data } = await createUserByAdmin({
      email,
      password,
      name,
      lastName,
      phone,
      countryCode,
      role: role || UserRole.Cliente,
      vendedor,
      referidoPor,
    });

    toast.success("Usuario registrado con éxito");
    return data ? { uid: data.uid, email: data.email } : null;
  } catch (error: unknown) {
    if (isAuthError(error)) {
      handleAuthError();
      return null;
    }
    const firebaseError = error as FirebaseError & { code?: string };
    toast.error(getCustomErrorMessage(firebaseError.code) || firebaseError.message);
    return null;
  }
}
